import React, { useRef, useEffect } from 'react'
import { useStateValue } from '@State'
import { CodeGraderQuestion } from './CodeGraderQuestion'
import { CoderQuestion } from './CoderQuestion'
import { EssayQuestion } from './EssayQuestion'
import { FileUploadQuestion } from './FileUploadQuestion'
import { HotspotQuestion } from './HotspotQuestion'
import { MultipleChoiceQuestion } from './MultipleChoiceQuestion'
import { MatchingQuestion } from './MatchingQuestion'
import { NGNBowtieQuestion } from './NGNBowtieQuestion'
import { NGNDragDropQuestion } from './NGNDragDropQuestion'
import { NGNDropdownQuestion } from './NGNDropdownQuestion'
import { NGNDropdownTableQuestion } from './NGNDropdownTableQuestion'
import { NGNGroupingQuestion } from './NGNGroupingQuestion'
import { NGNHighlightQuestion } from './NGNHighlightQuestion'
import { NGNMatrixQuestion } from './NGNMatrixQuestion'
import { ShortAnswerQuestion } from './ShortAnswerQuestion'
import { TrueFalseQuestion } from './TrueFalseQuestion'
import { QuestionNumber } from './utils/QuestionNumber'

const withQuestionNumber = (Component) => {
  const Wrapped = React.memo(({ number, ...props }) => {
    const containerRef = useRef(null)
    const [{ showFeedback }] = useStateValue()
    useEffect(() => {
      if (containerRef.current && window.MathLive?.me_renderMathInElement) {
        window.MathLive.me_renderMathInElement(containerRef.current)
      }
    }, [showFeedback])
    return (
      <div className="d-flex" ref={containerRef}>
        {number != null && <QuestionNumber number={number} />}
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <Component {...props} />
        </div>
      </div>
    )
  })
  Wrapped.displayName = `WithNumber(${Component.displayName || Component.name})`
  return Wrapped
}

export { UnsupportedQuestion } from './UnsupportedQuestion'

// Requires a StateProvider ancestor — components use useStateValue() for MathLive re-rendering.
export const QUESTION_COMPONENTS = {
  multiplechoice: withQuestionNumber(MultipleChoiceQuestion),
  matching: withQuestionNumber(MatchingQuestion),
  truefalse: withQuestionNumber(TrueFalseQuestion),
  essay: withQuestionNumber(EssayQuestion),
  fileupload: withQuestionNumber(FileUploadQuestion),
  codegrader: withQuestionNumber(CodeGraderQuestion),
  coder: withQuestionNumber(CoderQuestion),
  shortanswer: withQuestionNumber(ShortAnswerQuestion),
  ngn_dropdown: withQuestionNumber(NGNDropdownQuestion),
  'ngn-dropdown-table': withQuestionNumber(NGNDropdownTableQuestion),
  ngn_highlight: withQuestionNumber(NGNHighlightQuestion),
  'ngn-dragdrop': withQuestionNumber(NGNDragDropQuestion),
  'ngn-bowtie': withQuestionNumber(NGNBowtieQuestion),
  'ngn-matrix': withQuestionNumber(NGNMatrixQuestion),
  'ngn-grouping': withQuestionNumber(NGNGroupingQuestion),
  hotspot: withQuestionNumber(HotspotQuestion),
}
